import { http } from './config'

export default {
  rankingPorUnidades: (data) => {
    console.log(data)
    return http.post('financeiro/rankingPorUnidade', data)
  },
  rankingEspecialidade: (data) => {
    return http.post('financeiro/rankingEspecialidade', data)
  },
  rankingMedicos: (data) => {
    return http.post('financeiro/rankingMedicos', data)
  },
  rankingConvenio: (data) => {
    return http.post('financeiro/rankingConvenio', data)
  },
  rankingGeral: (data) => {
    return http.post('financeiro/geral', data)
  }
}
